module.exports = __webpack_public_path__ + "img/04.140b392c.jpg";